import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptSectionTitleSettings } from "../adapters/adaptSectionTitleSettings";

const fetchSettings = async () => {
	const response = await cmsClient.get<CMSSetting[]>("/settings/");
	return response.data;
};

const useSectionTitleSettings = () => {
	return useQuery(["section-title-settings"], fetchSettings, {
		select: adaptSectionTitleSettings
	});
};

export default useSectionTitleSettings;
